import {
  stateAbbreviations,
  stateNames,
  monthList,
  weekdayList,
  australiaStateAbbreviations,
  australiaStateNames,
  canadaProvinceAbbreviations,
  canadaProvinceNames,
  passFailChoices
} from 'apps/builder/lib/data/choiceList'

export const transformCommonListOptions = option => {
  const newList = option.values.map((entry, i) => {
    return {
      text: entry,
      position: i,
      placeholder: 'Type your choice here and press Enter',
    }
  })
  return { ...option, values: newList }
}
export const commonListOptions = [
  {
    description: 'US State Abbreviations',
    values: stateAbbreviations,
    id: 1,
  },
  {
    description: 'US State Names',
    values: stateNames,
    id: 2,
  },
  {
    description: 'Month',
    values: monthList,
    id: 3,
  },
  {
    description: 'Weekday',
    values: weekdayList,
    id: 4,
  },
  {
    description: 'Australian State Abbreviations',
    values: australiaStateAbbreviations,
    id: 7,
  },
  {
    description: 'Australian State Names',
    values: australiaStateNames,
    id: 8,
  },
  {
    description: 'Canadian Province Abbreviations',
    values: canadaProvinceAbbreviations,
    id: 5,
  },
  {
    description: 'Canadian Province Names',
    values: canadaProvinceNames,
    id: 6,
  },
  {
    description: 'Pass/Fail',
    values: passFailChoices,
    id: 9
  }
].map(transformCommonListOptions)
